import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfirmationBuilder } from '../builders/confirmation.builder';
import { Confirmation } from '../models/confirmation';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  private readonly builder = inject(ConfirmationBuilder);

  private readonly showSource$ = new Subject<Confirmation>();

  public get show$(): Observable<Confirmation> {
    return this.showSource$.asObservable();
  }

  public show(factory: (builder: ConfirmationBuilder) => Confirmation): void {
    this.showSource$.next(factory(this.builder));
  }
}
